const defaultLanguage = 'hu'

module.exports = {
  allowedLanguages: [defaultLanguage, 'en', 'de']
}
